export default "https://assets.egbcdn.net/assets/packs/_/images/svg_icons/app-chat-1595cb6d393dd178fa371bb4f21629cf.svg";